import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AllProducers = lazy(() => import('@pages/affiliate/AllProducers'));

export const AllProducersRoutes: RouteObject[] = [
  {
    path: '/all-producers',
    element: (
      <React.Suspense>
        <AllProducers />
      </React.Suspense>
    ),
  },
]; 